import React from "react";
import ThumbnailGallery from "./components/ThumbnailGallery";
import Features from "./components/Features";
import Description from "./components/Description";
import LocationAdvantages from "./components/LocationAdvantages";
import SameProject from "./components/SameProject.js";
import "./ProductDetail.css";

function ProductDetail({ product }) {
  return (
    <div className="product-detail-container container-xl text-center py-5">
      <div className="product-title"> {product.title}</div>
      <div className="product-detail-layout">
        <div className="col-md-7 col-sm-12 gallery-wrapper">
          <ThumbnailGallery images={product.gallery} />
        </div>
        <div className="col-md-5 col-sm-12">
          <Features features={product.features} />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <Description
            description={product.description}
            location={product.mapLocation}
          />
          <LocationAdvantages advantages={product.locationAdvantages} />
          <SameProject projectType={product.projectType} />
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
